module.exports = __webpack_public_path__ + "img/hr-electric-furnace-propeller-1.a12ad86f.png";